export default __webpack_public_path__ + "static/media/brown1.cbf2ef72.jpg";